module.exports = __webpack_public_path__ + "img/image.67e73c82.png";